module.exports = __webpack_public_path__ + "img/slide_3.cc7a7bf2.jpg";